import { AbconetApi } from '../General/AbconetApi';
import withCart from '../General/withCart';
import ReactModal from "react-modal";
var OrderDeliveryOption = require('../General/DeliveryOption').DeliveryOption;
import $ from "jquery";


export class OutOfStockRaw extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSaving: false,
            isNotified: false,
            modalOpen: false,
        }
    }

    handleClick() {

        if (this.props.supplyLocation != "") {
            this.sendToServer();
        }
        else {
            this.openModal();
        }       
    }

    setDeliveryOption(deliveryOption) {
        var currentCart = this.props.cart;

        if (deliveryOption.deliveryType == "PICK-UP") {
            currentCart.pickupLocation = deliveryOption.address;
        } else {
            currentCart.pickupLocation = null;
            currentCart.address = deliveryOption.address;
        }

        AbconetApi.post('/api/cart', currentCart).then((cart) => {
            $(document).trigger("CartUpdated", cart);
            this.setState({ isSettingCartLocation: false });
        });
    }


    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    sendToServer() {
        var self = this;
        this.setState({ isSaving: true });
        AbconetApi.post(`/api/user/notification/`, { stockcode: this.props.product.stockcode, location: this.props.supplyLocation }).then(function () {
            self.setState({
                isSaving: false,
                isNotified: true
            });
        });
    }


    renderUpdateLocationButton() {
        var btnText = 'Notify me';
        var btnClass = 'changes';

        var disabled = this.state.isSettingCartLocation;

        if (this.state.isSettingCartLocation) {
            btnText = 'Adding notification';
            btnClass = 'saving';
        }

        if (this.props.supplyLocation == "") {
            disabled = true;
        }

        return <button className={"btn btn-primary float-right mt-4 " + btnClass} disabled={disabled} onClick={this.sendToServer.bind(this)}>{btnText}</button>;
    }

    render() {
        var btnClass = 'changes';
        var disabled = false;

        var buttonText = "Notify me when in stock";

        if (this.state.isSaving) {
            disabled = true;
            buttonText = "Adding notification";
            btnClass = 'saving';
        }


        if (this.state.isNotified) {
            disabled = true;
            buttonText = "Will notify when in stock";
        }


        if (this.props.cart == null || this.props.cart.accountId === 0) {
            return <div>Product is out of stock, <a href="/register">register</a> to be notified when it is back in stock.</div>;
        }

        return <span>
            <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.closeModal.bind(this)} portalClassName="modal-portal" className="modal-dialog" overlayClassName="modal" bodyOpenClassName="modal-open" >
                <div className="modal-content">
                    <div className="bd p-15">
                        <h5 className="m-0">Set Location</h5>
                    </div>

                    <div className="mt-4">
                        <OrderDeliveryOption cart={this.props.cart} onChange={this.setDeliveryOption.bind(this)} hideSummary={true} showManageSites={false} oneColumn={true} showCreateNew={true} extraButton={this.renderUpdateLocationButton()} />

                    </div>
                    <button onClick={this.closeModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                </div>
            </ReactModal>
            <button className={"btn btn-outline-primary btn-sm " + btnClass} disabled={disabled} onClick={this.handleClick.bind(this)}>{buttonText}</button>
           </span>;
    }
}

export const OutOfStock = withCart(OutOfStockRaw);
